/**
 * 新疆热点
 * 2018-11-29
 * Yin.QingDong
 */
"use strict";
angular.module("countyHotSpotsModule", []).
controller("countyHotSpotsCtrl", ["$scope", "$q", "$filter", "$stateParams", "trsHttpService", "dateFilter", "$state", function($scope, $q, $filter, $stateParams, trsHttpService, dateFilter, $state) {
    $scope.data = {
        time: new Date(),
        timeRange: '',
        mapUrl: '',
        mapSelName: '',
        items: ''
    };
    $scope.status = {
        threeHot: {
            hotzj: "hot",
        }
    };
    $scope.page = {
        "CURRPAGE": 1,
        "PAGESIZE": 10,
        "ITEMCOUNT": 0,
        "PAGECOUNT": 1,
    };
    $scope.mapArea = [
        { "dictName": "lishui", "dictNum": "001020001" },
        { "dictName": "taizhou", "dictNum": "001020002" },
        { "dictName": "jiaxing", "dictNum": "001020003" },
        { "dictName": "ningbo", "dictNum": "001020004" },
        { "dictName": "hangzhou", "dictNum": "001020005" },
        { "dictName": "wenzhou", "dictNum": "001020006" },
        { "dictName": "huzhou", "dictNum": "001020007" },
        { "dictName": "shaoxing", "dictNum": "001020008" },
        { "dictName": "zhoushan", "dictNum": "001020009" },
        { "dictName": "quzhou", "dictNum": "001020010" },
        { "dictName": "jinhua", "dictNum": "001020011" }
    ];

    initData().then(function(data) {
        initStatus();
    });

    function initData() {
        var deferred = $q.defer();
        $scope.mapArea.forEach(function(item) {
            if (item.dictNum == $stateParams.district.substr(0, 9)) {
                $scope.data.mapUrl = item.dictName
            }
        })
        // 获取对应的区县名称 
        trsHttpService.httpServer("./planningCenter/hotFocus/regionalHotSpots/hotInfoVisual/data/areaName/" + $scope.data.mapUrl + ".json", "", "get").then(function(data) {
            data.forEach(function(item) {
                if (item.dictNum == $stateParams.district) {
                    $scope.data.mapSelName = item.dictName;
                    deferred.resolve($scope.data.mapSelName);
                }
            })
        });
        return deferred.promise;
    }
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        require(['echarts'], function(echarts) {
            var dom = document.getElementById("mapArea");
            var selectArea = $scope.data.mapSelName;
            var myChart = echarts.init(dom);
            var option = {
                title: {
                    text: "",
                },
                series: [{
                    name: '',
                    type: 'map',
                    mapType: "county",
                    // left: '2%', // 地图左边内边距
                    // top: '2%', // 地图上边内边距
                    roam: false, // 是否开启鼠标缩放和平移漫游
                    silent: true, // 沉默模式，禁止所有的点击和鼠标事件
                    // selectedMode: "single", //选中单选，多选multiple
                    itemStyle: {
                        normal: {
                            borderColor: '#5DB6F2',
                            areaColor: '#D5F5FF', //地图本身的颜色
                            borderWidth: 1,
                            label: {
                                show: false,
                                textStyle: {
                                    // color: "#bde6fd"
                                }
                            }
                        },
                        emphasis: {
                            // areaColor: '#D5F5FF',  //高亮时候地图显示的颜色
                            // borderColor: '#5DB6F2',
                            label: {
                                show: true,
                                textStyle: {
                                    // color: "#bde6fd"
                                }
                            }
                        }
                    },
                    data: [
                        { name: $scope.data.mapSelName, selected: true }
                    ]
                }]
            }
            //点击事件
            /*myChart.on('click', function(params) {
                console.log(params);
            })*/
            // 获取对应区县市区
            trsHttpService.httpServer("./planningCenter/hotFocus/regionalHotSpots/hotInfoVisual/data/echarts/" + $scope.data.mapUrl + ".json", "", "get").then(function(data) {
                echarts.registerMap('county', data);
                myChart.setOption(option);
            });
        });
    };

    /** [description] 当选择日期后执行的操作 */
    $scope.$watch("data.time", function() {
        $scope.data.timeRange = dateFilter($scope.data.time, 'yyyy-MM-dd').toString();
        requestData();
    });
    /** 请求热点列表数据 */
    function requestData() {
        var params = {
            typeid: "widget",
            serviceid: "hotpoint",
            modelid: "hotnewslist",
            field: '000',
            loadtime: $scope.data.timeRange,
            cluster_name: 'district_1',
            subjectarea: '0',
            area: $stateParams.district,
            page_no: $scope.page.CURRPAGE - 1,
            page_size: $scope.page.PAGESIZE
        }
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            $scope.page.ITEMCOUNT = data.TOTALITEMCOUNT;
            $scope.page.PAGECOUNT = data.TOTALPAGECOUNT;
            $scope.data.items = data.PAGEITEMS;
        });
    };
    $scope.pageChanged = function() {
        requestData();
    };
}]);